import { Icon, chevronUp, chevronDown } from '@wordpress/icons';
import { useState } from 'react';

export function Panel( props ) {
	const { header, body } = props;

	const [ showBody, setShowBody ] = useState( true );

	return (
		<div className="wp-block-mindmap-panel">
			<div
				className="wp-block-mindmap-panel__header"
				onClick={ () => setShowBody( ! showBody ) }
			>
				<span>{ header }</span>
				<Icon key="icon" icon={ showBody ? chevronUp : chevronDown } />
			</div>
			<div
				className="wp-block-mindmap-panel__body"
				style={ { display: showBody ? 'block' : 'none' } }
			>
				{ body }
			</div>
		</div>
	);
}
